const stripNonDigits = (phone: string) => phone.replace(/\D/g, '');
const stripLeadingZeros = (phone: string) => phone.replace(/^0+/, '');
const normalizePhone = (phone: string) => stripLeadingZeros(stripNonDigits(phone));

/**
 * Returns true if two phone numbers refer to the same number regardless of
 * formatting differences: leading zeros, country-code prefix (e.g. 353 / +353),
 * or extra punctuation are all ignored.
 */
const MIN_PHONE_LENGTH = 9;

export const arePhonesEqual = (a: string, b: string): boolean => {
  const na = normalizePhone(a);
  const nb = normalizePhone(b);
  if (!na || !nb) return false;
  if (na === nb) return true;
  const [shorter, longer] = na.length <= nb.length ? [na, nb] : [nb, na];
  return shorter.length >= MIN_PHONE_LENGTH && longer.endsWith(shorter);
};

/**
 * Format a phone number with +353 or +44
 * @param {string} value - The phone number to format
 */
export const formatPhone = (value: string) => {
  if (value.startsWith('353')) {
    // prefix with a plus and add a space after 353
    return `+${value.slice(0, 3)} ${value.slice(3).trim()}`;
  } else if (value.startsWith('44')) {
    // prefix with a plus and add a space after 44
    return `+${value.slice(0, 2)} ${value.slice(2).trim()}`;
  }
  return value;
};
